import { render } from "./DefaultField.vue?vue&type=template&id=2bf9edca&scoped=true"
import script from "./DefaultField.vue?vue&type=script&lang=js"
export * from "./DefaultField.vue?vue&type=script&lang=js"

import "./DefaultField.vue?vue&type=style&index=0&id=2bf9edca&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf9edca"]])

export default __exports__